import { z } from 'zod'

/**
 * Mirrors `Budget/Models/ScheduledTransactionModels.swift`. Dates are
 * ISO-8601 strings (iOS CodableRepository .iso8601). `amount` is a
 * positive magnitude — `transactionType` carries the direction; the
 * firing runner applies the sign when materializing a Transaction.
 */

export const FrequencySchema = z.enum(['weekly', 'biweekly', 'monthly', 'yearly'])
export type Frequency = z.infer<typeof FrequencySchema>

export const ScheduledTypeSchema = z.enum(['expense', 'income', 'transfer'])
export type ScheduledType = z.infer<typeof ScheduledTypeSchema>

export const ScheduledTransactionSchema = z.object({
  id: z.string(),
  accountId: z.string(),
  payeeName: z.string().nullable().optional(),
  categoryId: z.string().nullable().optional(),
  amount: z.number(),
  memo: z.string().nullable().optional(),
  frequency: FrequencySchema,
  startDate: z.string(),
  endDate: z.string().nullable().optional(),
  nextOccurrence: z.string(),
  transactionType: ScheduledTypeSchema,
  transferAccountId: z.string().nullable().optional(),
  isEnabled: z.boolean().default(true),
  lastCreatedDate: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
})
export type ScheduledTransaction = z.infer<typeof ScheduledTransactionSchema>
